import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages
import DashboardPage from './pages/DashboardPage';
import InventairePage from './pages/InventairePage.simple';
import LieuxPage from './pages/LieuxPage';
import ProfilPage from './pages/ProfilPage';
import LoginPage from './pages/LoginPage';
import LoginOAuthCallbackPage from './pages/LoginOAuthCallbackPage';

// Components
import Navigation from './components/Navigation';
import MobileLayoutOptimized from './components/MobileLayoutOptimized';
import MobileNavigation from './components/MobileNavigation';

// Services
import { authService } from './services/auth';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3,
    },
  },
});

const App: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Vérifier si l'utilisateur est déjà connecté
    if (authService.isAuthenticated()) {
      authService.getProfile()
        .then(setUser)
        .catch(() => {
          authService.logout();
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, []);

  const handleLogout = () => {
    authService.logout();
    setUser(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/oauth-callback" element={<LoginOAuthCallbackPage />} />
          <Route path="/*" element={
            user ? (
              <MobileLayoutOptimized>
                {/* Navigation mobile (seulement sur mobile) */}
                <div className="md:hidden">
                  <MobileNavigation />
                </div>
                
                {/* Navigation desktop (seulement sur desktop) */}
                <div className="hidden md:block">
                  <Navigation onLogout={handleLogout} user={user} />
                </div>
                
                <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/inventaire" element={<InventairePage />} />
                    <Route path="/lieux" element={<LieuxPage />} />
                    <Route path="/profil" element={<ProfilPage />} />
                  </Routes>
                </main>
              </MobileLayoutOptimized>
            ) : (
              <LoginPage />
            )
          } />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
};

export default App;